<div class="navblock hidden-print">
  <button class="btnadd" (click)="openCreateModal()">{{'Create key/label'|translate}}</button>

  <app-group-filter #groupFilter></app-group-filter>

  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)" />
  </div>
</div>
<div class="tablewrap admindrivers">
  <div class="table">
    <table fixedcols="[0, 11]" id="exporttable">
      <tr>
        <th>
            <switch-all-checkbox [items]="getObjects() | keysFilter : filter" />
        </th>
        <th class="object_column">{{'Name'|translate}}</th>
        <th class="object_column">{{'Description'|translate}}</th>
        <th class="object_column">{{'Code'|translate}}</th>
        <th>{{'Type'|translate}}</th>
        <th class="time_column">{{'Driver'|translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let key of getObjects() | keysFilter : filter | pagesfilter: pageInfoFilter">
        <td>
          <input readonly="readonly" type="checkbox" [(ngModel)]="key.IsChecked"/>
        </td>
        <td>{{key.Name}}</td>
        <td>{{key.Comment}}</td>
        <td>{{key.UID}}</td>
        <td>{{key.Type}}</td>
        <td>{{key.DriverName}}</td>
        <td class="hidden-print">
          <!--button class="btn_img btn_sync" title="{{'Synchronize keys'|translate}}" (click)="openSyncKeysDialog(key)"></button-->
          <button class="btn_img btn_edit" title="{{'Edit'|translate}}" (click)="openEditModal(key)"></button>
          <button class="btn_img btn_trush " (click)="deleteObject(key.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [viewMode]="'print excel pages'"
                      (onPageChange)="onPageChange($event)"
                      [items]="getObjects() | keysFilter : filter">
  <div export style="display:inline-block">
    <div class="btn_img btn_graygray dropup btn_export-import dropclick">
      <ul>
        <li (click)="myInput.click()">
          {{'Import'|translate}}
          <input type="file" #myInput class="btn_blue" style="visibility:hidden;display:none"
                 (change)="Incomingfile($event)"
                 onclick="this.value=null"
                 accept=".xls,.xlsx">
        </li>
        <li (click)="OpenExport()">{{'Export'|translate}}</li>
      </ul>
    </div>
  </div>
</app-footer-component>
<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
<template #objectsListDialog></template>
